import { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import axios from "axios";
import { useSelector } from 'react-redux';
import { useMsal, useAccount } from "@azure/msal-react";

import { FaEdit, FaAngleDown, FaAngleUp, FaPlus, FaTrashAlt } from 'react-icons/fa';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form'; // <-- Add this import
import { Link, NavLink } from "react-router-dom";
import PersonSelector from "../person/PersonSelector";
import AttendanceTypeSelector from "./AttendanceTypeSelector";
import AttendanceRoleSelector from "./AttendanceRoleSelector";
import { uuidv4 } from "../Util"
import authConfig from "../../authConfig";
function AttendanceEditor(props) {
    const { t, i18n } = useTranslation();
    const language = useSelector((state) => state.language.value);
    const [show, setShow] = useState(false);

    const [newAttende, setNewAttendee] = useState({
        id: uuidv4(),
        person: null,
        attendance: "Expected",
        role: "",
        commentEn: "",
        commentCy: ""
    });

    const [apologies, setApologies] = useState([]);
    const { instance, accounts } = useMsal();
    const account = useAccount(accounts[0] || {});

    // State for confirm recind modal
    const [showRecindModal, setShowRecindModal] = useState(false);
    const [recindMemberId, setRecindMemberId] = useState(null);

    // State for change apology type modal
    const [showChangeTypeModal, setShowChangeTypeModal] = useState(false);
    const [changeTypeMemberId, setChangeTypeMemberId] = useState(null);
    const [selectedApologyType, setSelectedApologyType] = useState("");
    const [apologyTypes, setApologyTypes] = useState(["Illness", "Work", "Other"]); // Example types, adjust as needed

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    // Fetch apologies when modal is opened, using MSAL token
    useEffect(() => {
        if (show && props.meeting?.id && account) {
            instance
                .acquireTokenSilent({
                    scopes: authConfig.api.scopes,
                    account: account
                })
                .then(response => {
                    axios
                        .get(authConfig.api.urls.getMeetingMemberApologies + "/" + props.meeting.id, {
                            headers: { Authorization: `Bearer ${response.accessToken}` }
                        })
                        .then(res => {
                            setApologies(res.data);
                        })
                        .catch(() => setApologies([]));
                })
                .catch(() => setApologies([]));
        }
    }, [show, props.meeting?.id, account, instance]);

    const handleSelectNewperson = (o) => {
        newAttende.person = o;
        setNewAttendee({ ...newAttende });
    }
    const handleSelectNewAttendance = (o) => {
        newAttende.attendance = o;
        setNewAttendee({ ...newAttende });
    }
    const handleSelectNewRole = (o) => {
        newAttende.role = o;
        setNewAttendee({ ...newAttende });
    }

    // Recind apology handler
    const handleRecindApology = async (memberId) => {
        if (!memberId) return;
        try {
            const response = await instance.acquireTokenSilent({
                scopes: authConfig.api.scopes,
                account: account
            });
            await axios.get(authConfig.api.urls.getMeetingRecindApology + "/" + memberId, {
                headers: { Authorization: `Bearer ${response.accessToken}` }
            });
            // Optionally refresh apologies list
            if (props.meeting?.id) {
                const res = await axios.get(authConfig.api.urls.getMeetingMemberApologies + "/" + props.meeting.id, {
                    headers: { Authorization: `Bearer ${response.accessToken}` }
                });
                setApologies(res.data);
            }
        } catch (err) {
            // handle error (optional)
        }
    };

    // Show confirm recind modal
    const handleShowRecindModal = (memberId) => {
        setRecindMemberId(memberId);
        setShowRecindModal(true);
    };

    // Confirm recind action
    const handleConfirmRecind = async () => {
        if (recindMemberId) {
            await handleRecindApology(recindMemberId);
        }
        setShowRecindModal(false);
        setRecindMemberId(null);
    };

    // Cancel recind action
    const handleCancelRecind = () => {
        setShowRecindModal(false);
        setRecindMemberId(null);
    };

    // Show change apology type modal
    const handleChangeApologyType = (memberId) => {
        setChangeTypeMemberId(memberId);
        // Optionally, set the current type as selected
        const apology = apologies.find(x => x.memberId === memberId);
        setSelectedApologyType(apology?.type || "");
        setShowChangeTypeModal(true);
    };

    // Confirm change apology type
    const handleConfirmChangeType = async () => {
        if (!changeTypeMemberId || !selectedApologyType) {
            setShowChangeTypeModal(false);
            setChangeTypeMemberId(null);
            return;
        }
        try {
            const response = await instance.acquireTokenSilent({
                scopes: authConfig.api.scopes,
                account: account
            });
            await axios.post(
                authConfig.api.urls.getMeetingChangeApologyType,
                {
                    memberId: changeTypeMemberId,
                    meetingId: props.meeting.id,
                    type: selectedApologyType
                },
                { headers: { Authorization: `Bearer ${response.accessToken}` } }
            );
            // Refresh apologies list
            if (props.meeting?.id) {
                const res = await axios.get(authConfig.api.urls.getMeetingMemberApologies + "/" + props.meeting.id, {
                    headers: { Authorization: `Bearer ${response.accessToken}` }
                });
                setApologies(res.data);
                //for (var apology in res.data) {

                //}
                let newattendees = [];
                for (var att of props.meeting.attendees) {
                    if (att.person.member) {
                        console.log(att.person.member.id);
                        if (att.person.member.id === changeTypeMemberId) {
                            att.attendance = selectedApologyType
                            newattendees.push(att);
                        } else {
                            newattendees.push(att);
                        }
                    } else {
                        newattendees.push(att);
                    }
                }
                if (props.onChange) {
                    props.onChange(newattendees);
                }
            }
        } catch (err) {
            // handle error (optional)
        }
        setShowChangeTypeModal(false);
        setChangeTypeMemberId(null);
    };

    // Cancel change type action
    const handleCancelChangeType = () => {
        setShowChangeTypeModal(false);
        setChangeTypeMemberId(null);
    };

    const attendees = props.meeting.attendees === undefined ?
        null :
        props.meeting.attendees.sort(
            (a, b) => {
                return (a.person.firstname + a.person.lastname) > (b.person.firstname + b.person.lastname) ? 1 : -1
            });

    const handleChangeAttendance = (o, attendee) => {
        let newattendees = [];
        for (var att of props.meeting.attendees) {
            if (att.id === attendee.id) {
                attendee.attendance = o;
                newattendees.push(attendee);
            } else {
                newattendees.push(att);
            }
        }
        if (props.onChange) {
            props.onChange(newattendees);
        }
    }
    const handleRemove = (o) => {
        console.log(o);
        let newattendees = [];
        for (var attendee of props.meeting.attendees) {
            if (attendee.id === o.id) {
                // skip
            } else {
                newattendees.push(attendee);
            }
        }
        if (props.onChange) {
            props.onChange(newattendees);
        }
    }
    const handleAddNew = () => {
        let newattendees = [...props.meeting.attendees];
        if (newattendees.filter(z => z.person.id === newAttende.person.id).length === 0) {
            newattendees.push(newAttende);
            if (props.onChange) {
                props.onChange(newattendees);
            }
        }
        setNewAttendee({
            id: uuidv4(),
            person: null,
            attendance: "Expected",
            role: "",
            commentEn: "",
            commentCy: ""
        });
    }
    return (
        <>
            <Button size="sm" variant="success" onClick={handleShow}>
                {t("Attendance Details")}
            </Button>
            <Modal show={show} onHide={handleClose} size="xl">
                <Modal.Header closeButton>
                    <Modal.Title>{t("Attendance Details")}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Add new attendee;
                    <Row>
                        <Col xs="3">
                            <PersonSelector value={newAttende.person} onChange={handleSelectNewperson} />
                        </Col>
                        <Col xs="3">
                            <AttendanceRoleSelector value={newAttende.role} onChange={handleSelectNewRole} />
                        </Col>
                        <Col xs="4">
                            <AttendanceTypeSelector value={newAttende.attendance} onChange={handleSelectNewAttendance} />
                        </Col>
                        <Col xs="2">
                            <Button
                                size="sm"
                                variant="success"
                                onClick={handleAddNew}
                                disabled={newAttende.person === null || newAttende.role === "" || newAttende.attendance === "" || props.meeting.attendees.filter(z => z.person.id === newAttende.person.id).length > 0}
                            >

                                Add
                            </Button>
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Body>
                    {props.meeting && props.meeting.attendees !== undefined ? props.meeting.attendees.map((attendee, index) => {
                        const memberId = attendee.person?.member?.id;
                        const isReadonly = apologies.some(x => x.memberId === memberId);
                        const apology = apologies.find(x => x.memberId === memberId);
                        const rowStyles = [
                            { backgroundColor: "#F0F0F0" },
                            { backgroundColor: "#ffffff" }
                        ];
                        const style = rowStyles[index % 2];
                        return (
                            <>
                                <Row key={index} style={style}>
                                    <Col xs="3">
                                        {t(attendee.person.title) + " " + attendee.person.firstname + " " + attendee.person.lastname}
                                    </Col>
                                    <Col xs="3">{t(attendee.role)}</Col>
                                    <Col xs="4">
                                        <AttendanceTypeSelector
                                            value={attendee.attendance}
                                            onChange={(o) => { handleChangeAttendance(o, attendee); }}
                                            isDisabled={isReadonly}
                                        />
                                    </Col>
                                    <Col xs="2">
                                        {!isReadonly ? (
                                            <Button
                                                size="sm"
                                                variant="danger"
                                                onClick={(o) => { handleRemove(attendee); }}
                                            ><FaTrashAlt /></Button>
                                        ) : (
                                            <>
                                                <Button
                                                    size="sm"
                                                    onClick={() => handleChangeApologyType(memberId)}
                                                    disabled={!memberId}
                                                >
                                                    Type
                                                </Button>&nbsp;
                                                <Button
                                                    size="sm"
                                                    variant="warning"
                                                    onClick={() => handleShowRecindModal(memberId)}
                                                    disabled={!memberId}
                                                >
                                                    {t("Recind ")}
                                                </Button>
                                            </>
                                        )}
                                    </Col>
                                </Row>
                                {isReadonly ? (
                                    <Row style={style}>
                                        <Col xs="12">Apology reason: {apology.reason}</Col>
                                    </Row>
                                ) : (<></>)}
                            </>
                        )
                    }) : ''}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={handleClose}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Confirm Recind Apology Modal */}
            <Modal show={showRecindModal} onHide={handleCancelRecind} centered>
                <Modal.Header closeButton>
                    <Modal.Title>{t("Confirm Rescind Apology")}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {t("Are you sure you want to rescind this apology?")}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCancelRecind}>
                        {t("Cancel")}
                    </Button>
                    <Button variant="warning" onClick={handleConfirmRecind}>
                        {t("Rescind")}
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Change Apology Type Modal */}
            <Modal show={showChangeTypeModal} onHide={handleCancelChangeType} centered>
                <Modal.Header closeButton>
                    <Modal.Title>{t("Change Apology Type")}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group>
                            <Form.Label>{t("Select new apology type")}</Form.Label>
                            <AttendanceTypeSelector
                                value={selectedApologyType}
                                onChange={(o) => { setSelectedApologyType(o); }}
                                isDisabled={false}
                            />
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCancelChangeType}>
                        {t("Cancel")}
                    </Button>
                    <Button
                        variant="primary"
                        onClick={handleConfirmChangeType}
                        disabled={!selectedApologyType}
                    >
                        {t("Change Type")}
                    </Button>
                </Modal.Footer>
            </Modal>
        </>);
}

export default AttendanceEditor;